/**
 * Combinators are small functions that perform targeted validation tasks
 * @namespace combinators
 */

module.exports = {
  alpha: require('./alpha'),
  alphanumeric: require('./alphanumeric'),
  array: require('./array'),
  boolean: require('./boolean'),
  cardinal: require('./cardinal'),
  date: require('./date'),
  email: require('./email'),
  'empty-string': require('./empty-string'),
  integer: require('./integer'),
  ipv4: require('./ipv4'),
  ipv6: require('./ipv6'),
  max: require('./max'),
  'max-length': require('./max-length'),
  min: require('./min'),
  'min-length': require('./min-length'),
  'no-same-values': require('./no-same-values'),
  numeric: require('./numeric'),
  'numeric-range': require('./numeric-range'),
  object: require('./object'),
  objectid: require('./objectid'),
  'older-than': require('./older-than'),
  pattern: require('./pattern'),
  required: require('./required'),
  schema: require('./schema'),
  'string-length': require('./string-length'),
  unique: require('./unique'),
  url: require('./url'),
  uuid: require('./uuid'),
  whitespace: require('./whitespace'),
  'alphanumeric-special': require('./alphanumeric-special'),
  abn: require('./abn'),
  bsb: require('./bsb'),
}
